var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('video-overlay', {
    ref: "overlay",
    attrs: {
      "paused": _vm.paused,
      "t": _vm.t,
      "duration": _vm.duration,
      "loading": _vm.loadStatus.pending || _vm.didInitGainNodes && _vm.missingData || !_vm.scale || _vm.loadMediaBoundaryStatus.pending,
      "disabled": _vm.loadStatus.pending || _vm.needsReload || !_vm.scale,
      "allow-fullscreen": !_vm.IS_MOBILE
    },
    on: {
      "update:paused": function ($event) {
        _vm.paused = $event;
      },
      "update:t": function ($event) {
        _vm.t = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  }, [_c('v-responsive-bounds', {
    staticClass: "mx-auto overflow-hidden black",
    attrs: {
      "aspect-ratio": _vm.video.w / _vm.video.h
    },
    on: {
      "updated": function (bounds) {
        return _vm.scale = _vm.SUPER_SAMPLE * bounds.w / _vm.video.w;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var bounds = _ref.bounds;
        return [_c('canvas', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.needsReload,
            expression: "!needsReload"
          }],
          ref: "canvas",
          staticStyle: {
            "transform-origin": "top left"
          },
          style: {
            transform: `scale(${1 / _vm.SUPER_SAMPLE})`
          },
          attrs: {
            "width": _vm.SUPER_SAMPLE * bounds.w,
            "height": _vm.SUPER_SAMPLE * bounds.h
          }
        }), _vm.needsReload ? _c('div', {
          staticClass: "absolute-fill d-flex flex-column justify-center align-center",
          staticStyle: {
            "z-index": "1"
          }
        }, [_c('div', {
          staticClass: "white--text overline text-center"
        }, [_vm.loadStatus.pending ? _c('span', [_vm._v("Optimizing…")]) : _c('span', [_vm._v("Project updated")])]), _c('v-btn', {
          attrs: {
            "loading": _vm.loadStatus.pending,
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.load.apply(null, arguments);
            }
          }
        }, [_vm._v(" Reload"), _c('v-icon', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiRefresh)
          }
        })], 1)], 1) : _vm._e()];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }